// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailsProgressBar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1rem;
  border-left: 1px solid var(--bs-primary);
}
.DetailsProgressBar-Title {
  font-size: 1rem;
  font-weight: 500;
  align-self: flex-start;
  text-transform: uppercase;
}
.DetailsProgressBar-Container {
  display: flex;
  gap: 0.75rem;
}
.DetailsProgressBar-LeftLabel, .DetailsProgressBar-RightLabel {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 1.33rem;
  line-height: 1;
  font-weight: 700;
}
.DetailsProgressBar-LeftLabel {
  text-align: left;
}
.DetailsProgressBar-RightLabel {
  text-align: right;
}
.DetailsProgressBar-Bar {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  width: 145px;
}
.DetailsProgressBar {
  /* ensure the bootstrap progress bar is vertically centered and visible */
}
.DetailsProgressBar .progress {
  width: 100%;
  height: 0.8rem;
  margin: 0;
  background-clip: padding-box;
}
.DetailsProgressBar .progress-bar {
  display: block;
  height: 100%;
  line-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/DynamicReport/components/DetailsProgressBar/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,YAAA;AAAJ;AAGE;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAJJ;AApCA;EA2CE,yEAAA;AAJF;AAKE;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,4BAAA;AAHJ;AAME;EACE,cAAA;EACA,YAAA;EACA,cAAA;AAJJ","sourcesContent":[".DetailsProgressBar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-left: 1rem;\n  border-left: 1px solid var(--bs-primary);\n\n  &-Title {\n    font-size: 1rem;\n    font-weight: 500;\n    align-self: flex-start;\n    text-transform: uppercase;\n  }\n\n  &-Container {\n    display: flex;\n    gap: 0.75rem;\n  }\n\n  &-LeftLabel,\n  &-RightLabel {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    font-size: 1.33rem;\n    line-height: 1;\n    font-weight: 700;\n  }\n\n  &-LeftLabel {\n    text-align: left;\n  }\n  &-RightLabel {\n    text-align: right;\n  }\n\n  &-Bar {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    width: 145px;\n  }\n\n  /* ensure the bootstrap progress bar is vertically centered and visible */\n  .progress {\n    width: 100%;\n    height: 0.8rem;\n    margin: 0;\n    background-clip: padding-box;\n  }\n\n  .progress-bar {\n    display: block;\n    height: 100%;\n    line-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
